import { render, staticRenderFns } from "./TextFieldLabel.vue?vue&type=template&id=1bf91af2&scoped=true&"
import script from "./TextFieldLabel.vue?vue&type=script&lang=js&"
export * from "./TextFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf91af2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf91af2')) {
      api.createRecord('1bf91af2', component.options)
    } else {
      api.reload('1bf91af2', component.options)
    }
    module.hot.accept("./TextFieldLabel.vue?vue&type=template&id=1bf91af2&scoped=true&", function () {
      api.rerender('1bf91af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Label/TextFieldLabel.vue"
export default component.exports